/** Campos ocultos del pagador para formularios POST a pasarelas (web). */

const firstNonEmpty = (...vals) => {
    for (const v of vals) {
        if (v == null) continue;
        const s = String(v).trim();
        if (s && s !== 'undefined' && s !== 'null') return s;
    }
    return '';
};

const normalizeGatewayPhone = (raw) => {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.startsWith('57') && digits.length >= 12) {
        digits = digits.slice(2);
    }
    if (digits.length > 10) {
        digits = digits.slice(-10);
    }
    return digits.length >= 7 ? digits : '';
};

const normalizeGatewayDocument = (raw, documentType) => {
    const s = firstNonEmpty(raw);
    if (!s) return '';
    const type = String(documentType || '').trim().toUpperCase();
    if (type === 'NIT') {
        return s.replace(/\s/g, '');
    }
    return s.replace(/\D/g, '');
};

export const getGatewayPayFields = (profile = {}, booking = {}) => {
    const rawDocument = firstNonEmpty(
        profile.documentId,
        profile.verifyId,
        profile.document_id,
        profile.cedula,
        profile.nationalId,
        profile.daviplataDocumentId,
        booking.customer_document
    );
    const documentType = profile.documentType
        || (String(rawDocument).includes('-') ? 'NIT' : 'CC');
    const documentNumber = normalizeGatewayDocument(rawDocument, documentType);
    const municipality = profile.municipality || '';
    const department = profile.department || '';
    const addressParts = [profile.address, municipality, department]
        .map((p) => (p == null ? '' : String(p).trim()))
        .filter(Boolean);
    const mobile_no = normalizeGatewayPhone(firstNonEmpty(
        profile.mobile,
        profile.phone,
        profile.phoneNumber,
        booking.customer_contact,
        booking.customer_phone
    ));

    return {
        document_number: documentNumber,
        document_type: documentType,
        address: addressParts.join(', '),
        municipality,
        department,
        mobile_no,
    };
};

export const GatewayPayHiddenFields = ({ profile, booking, style }) => {
    const fields = getGatewayPayFields(profile, booking);
    return (
        <>
            <input type="hidden" name="document_number" value={fields.document_number} style={style} />
            <input type="hidden" name="document_type" value={fields.document_type} style={style} />
            <input type="hidden" name="address" value={fields.address} style={style} />
            <input type="hidden" name="municipality" value={fields.municipality} style={style} />
            <input type="hidden" name="department" value={fields.department} style={style} />
            {fields.mobile_no ? (
                <input type="hidden" name="mobile_no" value={fields.mobile_no} style={style} />
            ) : null}
        </>
    );
};
